import { BaseTier } from "./tier-base.model";

export class LclTier extends BaseTier {
  constructor(
    public id: number,
    protected discriminator: string,
    protected name: string,
    protected description: string,
    protected wmPrice: number,
  ) {
    super(id, discriminator, name, description);
  }

  public getWmPrice(): number {
    return this.wmPrice;
  }
  public setWmPrice(param: number) {
    this.wmPrice = param;
  }

  public getRequestParams(): any {
    return {
      name: this.getName(),
      description: this.getDescription(),
      wmPrice: this.getWmPrice(),
    };
  }
}
